module.exports = __webpack_public_path__ + "img/cj.45ef70d3.png";